import { FaqOtherQuestionsComponent } from '@loggedin-content/faq/faq-other-questions/faq-other-questions.component';
import { FaqPolicyComponent } from '@loggedin-content/faq/faq-policy/faq-policy.component';
import { FaqClaimsComponent } from '@loggedin-content/faq/faq-claims/faq-claims.component';
import { FaqHomeComponent } from '@loggedin-content/faq/faq-home/faq-home.component';
import { FaqComponent } from '@loggedin-content/faq/faq.component';
import { PaymentConfirmationComponent } from '@loggedin-content/screens/payment-confirmation/payment-confirmation.component';
import { MakePaymentComponent } from '@loggedin-content/billing/make-payment/make-payment.component';
import { RegisterPaymentComponent } from '@loggedin-content/billing/register-payment/register-payment.component';
import { RegisterPaymentWidgetComponent } from '@loggedin-content/billing/register-payment-widget/register-payment-widget.component';
import { AddPolicyConflictsComponent } from '@loggedin-content/my-insurance/add-policy/add-policy-conflicts/add-policy-conflicts.component';
// ---- Packages | Helpers ---- //
import { Routes } from '@angular/router';

import {
  ErrorLinkExpireComponent,
  Error404Component,
  Error504Component,
  Error400Component,
  Error401Component,
  Error403Component,
  Error408Component,
  Error410Component,
  Error502Component,
  Error503Component,
  Error500Component,
  ErrorMaintenceComponent,
} from '@mapfre-design-library/src/public_api';

// ---- Guards ----- //
import { AuthGuard } from './_guards/auth.guard';
import { SignUpGuard } from './_guards/signup.guard';
import { BillinConfirmGuard } from './_guards/billin-confirm.guard';

// --- components ---- //
import { ProfileEditEmailComponent } from '@loggedin-content/profile/profile-edit-email/profile-edit-email.component';
import { ProfileCheckingAccountComponent } from '@loggedin-content/profile/profile-checking-account/profile-checking-account.component';
import { ProfilePhoneComponent } from '@loggedin-content/profile/profile-phone/profile-phone.component';
import { InformationHomeComponent } from '@loggedin-content/information/information-home/information-home.component';
import { ProfileEditPasswordComponent } from '@loggedin-content/profile/profile-edit-password/profile-edit-password.component';
import { ProfileMainComponent } from '@loggedin-content/profile/profile-main/profile-main.component';
import { InformationProductsComponent } from '@loggedin-content/information/information-products/information-products.component';
import { InformationAboutComponent } from '@loggedin-content/information/information-about/information-about.component';
import { InformationDiscountsComponent } from '@loggedin-content/information/information-discounts/information-discounts.component';
import { InformationRenewalComponent } from '@loggedin-content/information/information-renewal/information-renewal.component';
import { InformationCancelComponent } from '@loggedin-content/information/information-cancel/information-cancel.component';
import { InformationLegalComponent } from '@loggedin-content/information/information-legal/information-legal.component';
import { ClaimsDetailComponent } from '@loggedin-content/claims/claims-detail/claims-detail.component';
import { ClaimsHomeComponent } from '@loggedin-content/claims/claims-dashboard-main/claims-home.component';
import { ProfileEmailConfirmComponent } from '@loggedin-content/profile/profile-email-confirm/profile-email-confirm.component';
import { PolicyDetailsComponent } from '@loggedin-content/my-insurance/details/details.component';
import { BillingDetailsComponent } from '@loggedin-content/my-insurance/billing/billing.component';
import { BillingRequestComponent } from '@loggedin-content/billing/billing-request/billing-request.component';
import { DocumentDetailsComponent } from '@loggedin-content/my-insurance/documents/documents.component';
import { DashboardMainComponent } from './components/dashboard/dashboard-main.component';
import { BillingMainComponent } from '@loggedin-content/billing/billing-main.component';
import { BillingNewpaymentComponent } from '@loggedin-content/billing/billing-newpayment/billing-newpayment.component';
import { BillingConfirmComponent } from '@loggedin-content/billing//billing-confirm/billing-confirm.component';
import { CancellationRequestComponent } from '@loggedin-content/billing/self-request/cancellation-request/cancellation-request.component';
import { RequestSuccessComponent } from '@loggedin-content/billing/self-request/request-success/request-success.component';
import { LinkPolicyComponent } from '@loggedin-content/my-insurance/add-policy/link-policy/link-policy.component';
import { MyInsuranceComponent } from '@loggedin-content/my-insurance/my-insurance.component';
import { LoggedinContentComponent } from '@loggedin-content/loggedin-content.component';
import { MyInsuranceMainComponent } from '@loggedin-content/my-insurance/my-insurance-main/my-insurance-main.component';
import { MyInsuranceHomeComponent } from '@loggedin-content/my-insurance/my-insurance-home/my-insurance-home.component';
import { PaperlessBillComponent } from '@loggedin-content/billing/paperless/paperless-bill/paperless-bill.component';
import { PaperlessPayComponent } from '@loggedin-content/billing/paperless/paperless-pay/paperless-pay.component';
import { PaperlessPolicyComponent } from '@loggedin-content/billing/paperless/paperless-policy/paperless-policy.component';
import { PaperlessComponent } from '@loggedin-content/billing/paperless/paperless.component';
import { PaperlessFirstTimeComponent } from '@loggedin-content/billing/paperless/paperless-time/paperless-time.component';
import { PaperlessPayEnrollComponent } from '@loggedin-content/billing/paperless/paperless-pay/enroll/enroll.component';
import { PaperlessPayConfirmComponent } from '@loggedin-content/billing/paperless/paperless-pay/confirm/confirm.component';
import { PolicyNotFoundComponent } from '@loggedin-content/my-insurance/add-policy/policy-not-found/policy-not-found.component';
import { EditPolicyDetailsComponent } from '@loggedin-content/my-insurance/add-policy/edit-policy-details/edit-policy-details.component';
import { ValidatePolicyRightsComponent } from '@my-insurance/add-policy/validate-policy-rights/validate-policy-rights.component';
import { PolicyInProcessComponent } from '@loggedin-content/my-insurance/add-policy/policy-in-process/policy-in-process.component';
import { BusinesspolicyDetectedComponent } from '@my-insurance/add-policy/businesspolicy-detected/businesspolicy-detected.component';
import { ValidateEmailScreenComponent } from './components/screens/signup-process/validate-email-screen/validate-email-screen.component';
import { XAttemptsComponent } from './components/screens/signup-process/x-attempts/x-attempts.component';
import { PersonalAssistanceComponent } from './components/screens/signup-process/personal-assistance/personal-assistance.component';
// ----- Routes ----- //
import { BillingComponent } from './routes/billing/billing.component';
import { DashboardComponent } from './routes/my-insurance/dashboard.component';
import { ForgotPasswordComponent } from './routes/forgot-password/forgot-password.component';
import { CreateNewPasswordComponent } from './routes/create-new-password/create-new-password.component';
import { SignupComponent } from './routes/signup/signup.component';
import { SignupProcessComponent } from './routes/signup/signup-process/signup-process.component';
import { TestingComponent } from './routes/testing/testing.component';
import { VerifyAccountComponent } from './routes/verify-account/verify-account.component';
import { ProfileSettingsComponent } from './routes/profile-settings/profile-settings.component';
import { AddressChangeComponent } from './routes/profile-settings/address-change/address-change.component';
import { ContactComponent } from './routes/contact/contact.component';
import { ClaimsComponent } from './routes/claims/claims.component';
import { InformationComponent } from './routes/information/information.component';
import { SignupNotFoundComponent } from './routes/signup/signup-process/signup-not-found/signup-not-found.component';
import { SignupEmailInUseComponent } from './routes/signup/signup-process/signup-email-in-use/signup-email-in-use.component';
import { SignupEditPolicyComponent } from './routes/signup/signup-process/signup-edit-policy/signup-edit-policy.component';
import { SignupCreatePasswordComponent } from './routes/signup/signup-process/signup-create-password/signup-create-password.component';
import { SignupBopComponent } from './routes/signup/signup-process/signup-bop/signup-bop.component';
import { SignupAddPolicyComponent } from './routes/signup/signup-process/signup-add-policy/signup-add-policy.component';
import { ChangeEmailComponent } from './routes/profile-settings/change-email/change-email.component';
import { ErrorComponent } from './routes/error/error-pages.component';
import { SignupPolicyLinkedToAnotherEmailComponent } from
  '@signup-process/signup-policy-linked-to-another-email/signup-policy-linked-to-another-email.component';
import { LoadingComponent } from './routes/loading/loading.component';
import { AutopayGuestComponent } from './components/screens/autopay-guest/autopay-guest.component';
import { BopComponent } from './routes/policy/bop/bop.component';
import { LoadDocumentsComponent } from '@loggedin-content/my-insurance/load-documents/load-documents.component';
import { PaymentErrorComponent } from '@loggedin-content/billing/payment-error/payment-error.component';
import { CreateCommercialAccountComponent } from '@signup-process/create-commercial-account/create-commercial-account.component';
import { ChangeProfileSettingsPasswordGuard } from './_guards/change-profile-settings-password.guard';
import { ChangeProfileSettingsEmailGuard } from './_guards/change-profile-settings-email.guard';
import { DeletePaymetInstSuccessComponent } from '@profile/delete-paymet-inst-success/delete-paymet-inst-success.component';
import { DeletePaymetInstErrorComponent } from
  '@loggedin-content/profile/delete-paymet-inst-error/delete-paymet-inst-error.component';
import { FaqBillingComponent } from '@loggedin-content/faq/faq-billing/faq-billing.component';
import { AutopayComponent } from '@loggedin-content/billing/autopay/autopay.component';
import { AppShellComponent } from './app-shell/app-shell.component';
import { PaymentusCardComponent } from '@loggedin-content/billing/paymentus-card/paymentus-card.component';
import { OdometerUpdateComponent } from '@loggedin-content/my-insurance/details/odometer-update/odometer-update.component';
import { ValidatePhoneComponent } from './components/screens/signup-process/validate-phone/validate-phone.component';
import { PhoneOtpComponent } from './components/screens/signup-process/phone-otp/phone-otp.component';
import { ConfirmEmailComponent } from './components/screens/signup-process/confirm-email/confirm-email.component';
import { AccountExistsComponent } from './components/screens/signup-process/account-exists/account-exists.component';
import { ValidateAccountComponent } from './components/screens/signup-process/validate-account/validate-account.component';
import { ValidateAccountEmailPhoneComponent } from '@signup-screen/validate-account-email-phone/validate-account-email-phone.component';
import { LinkExpireComponent } from './routes/link-expire/link-expire.component';
import { CommercialValidateEmailComponent } from '@signup-screen/commercial-validate-email/commercial-validate-email.component';
import { NotFoundCommercialComponent } from './components/screens/signup-process/not-found-commercial/not-found-commercial.component';
import { AchBillingConfirmComponent } from './ach-billing-confirm/ach-billing-confirm.component';
import { AchGuestPaymentConfirmComponent } from './ach-guest-payment-confirm/ach-guest-payment-confirm.component';
import { MakePaymentErrorComponent } from '@loggedin-content/billing/make-payment-error/make-payment-error.component';
import { AchGuestPaymentGuard } from './_guards/ach-guest-payment.guard';
import { AchPaymentComponent } from './components/forms/dynamic-forms/ach-payment/ach-payment.component';
import { AccountVerificationComponent } from '@signup-screen/account-verification/account-verification.component';
import { PayBillComponent } from './routes/pay-bill/pay-bill.component';
import { CoveragesComponent } from '@loggedin-content/my-insurance/coverages/coverages.component';
import { ManageContactComponent } from '@loggedin-content/profile/manage-contact/manage-contact.component';
import { EditContactComponent } from '@loggedin-content/profile/edit-contact/edit-contact.component';
import { InformationNotMatchComponent } from '@my-insurance/add-policy/information-not-match/information-not-match.component';
import { AddPolicyToAccountComponent } from '@my-insurance/add-policy/add-policy-to-account/add-policy-to-account.component';
import { PolicyAccountExistsComponent } from '@my-insurance/add-policy/policy-account-exists/policy-account-exists.component';
import { ExposuresDetailComponent } from '@loggedin-content/claims/exposures-detail/exposures-detail.component';
import { ClaimDocumentsComponent } from '@loggedin-content/claims/claim-documents/claim-documents.component';
import { UploadDocumentComponent } from '@loggedin-content/claims/upload-document/upload-document.component';
import { ExitPageGuard } from './_guards/exit-page.guard';
import { EmailNotAssociatedWithPolicyComponent } from
  '@my-insurance/add-policy/email-not-associated-with-policy/email-not-associated-with-policy.component';
import { EmailDoesntMatchTheAccountComponent } from
  '@my-insurance/add-policy/email-doesnt-match-the-account/email-doesnt-match-the-account.component';
import { AutopayUnenrolledComponent } from '@loggedin-content/billing/autopay-unenrolled/autopay-unenrolled.component';
import { PaymentInformationUpdatedComponent } from
  '@loggedin-content/billing/payment-information-updated/payment-information-updated.component';
import { CreateAccountTypeSelectionComponent } from '@dynamic-forms/create-account-type-selection/create-account-type-selection.component';
import { AccountActivateForLegacyComponent } from '@signup-screen/account-activate-for-legacy/account-activate-for-legacy.component';
import { AgentNotificationComponent } from './components/screens/agent-notification/agent-notification.component';
import { PaperlessEnrollementComponent } from '@loggedin-content/billing/paperless/paperless-enrollement/paperless-enrollement.component';
import { FaqAutopayComponent } from '@loggedin-content/faq/faq-autopay/faq-autopay.component';
import { ServiceMessageComponent } from './routes/service-message/service-message.component';
import { BillingDiscountComponent } from '@loggedin-content/billing/billing-discount/billing-discount.component';
import { BillingDiscountSuccessComponent } from '@loggedin-content/billing/billing-discount-success/billing-discount-success.component';
import { IdCardsWrapperComponent } from './components/id-cards-wrapper/id-cards-wrapper.component';
import { BillingStufferComponent } from '@routes/billing-stuffer/billing-stuffer.component';
import { SuccessfullPaperlessEnrollmentComponent } from '@routes/billing-stuffer/successfull-paperless-enrollment/successfull-paperless-enrollment.component';
import { EnrollDataDoesnotMatchComponent } from '@screens/enroll-data-doesnot-match/enroll-data-doesnot-match.component';
import { PolicyAlreadyEnrolledComponent } from '@routes/billing-stuffer/policy-already-enrolled/policy-already-enrolled.component';
import { PaperlessBillingStuffEnrollFormComponent } from '@dynamic-forms/paperless-billing-stuff-enroll-form/paperless-billing-stuff-enroll-form.component';
import { PaperlessEnrollmentRequestComponent } from '@routes/billing-stuffer/paperless-enrollment-request/paperless-enrollment-request.component';
import { BillingRefundRequestComponent } from '@loggedin-content/billing/billing-refund-request/billing-refund-request.component';
import { InitiateRefundComponent } from '@loggedin-content/billing/self-request/initiate-refund/initiate-refund.component';
import { UploadPolicyBillingDocumentComponent } from '@loggedin-content/my-insurance/upload-policy-billing-document/upload-policy-billing-document.component';
import { OtherRequestComponent } from '@loggedin-content/billing/self-request/other-request/other-request.component';
import { OtherRequestSuccessComponent } from '@loggedin-content/billing/self-request/other-request-success/other-request-success.component';
import { BillingContainerComponent } from '@routes/billing-new/billing-container/billing-container.component';
import { BillingPolicySelectorComponent } from '@loggedin-content/billing-new/billing-policy-selector/billing-policy-selector.component';
import { BillingNewDetailsComponent } from '@loggedin-content/billing-new/billing-new-details/billing-new-details.component';
import { BnDocumentsComponent } from '@loggedin-content/billing-new/bn-documents/bn-documents.component';
import { BnMakeAPaymentComponent } from '@loggedin-content/billing-new/bn-make-a-payment/bn-make-a-payment.component';
import { OktaCallbackComponent } from './routes/okta-callback/okta-callback.component';
import { TwoFactorAuthenticationComponent } from '@loggedin-content/profile/two-factor-authentication/two-factor-authentication.component';
import { EditTwoFactorAuthenticationComponent } from '@loggedin-content/profile/edit-two-factor-authentication/edit-two-factor-authentication.component';
import { WalletDetailsComponent } from '@loggedin-content/profile/wallet-details/wallet-details.component';
import { MakePaymentWidgetComponent } from '@loggedin-content/billing/make-payment-widget/make-payment-widget.component';
import { OneIncManageWalletGuard } from './_guards/one-inc-manage-wallet.guard';
import { OneIncGuestPaymentGuard } from './_guards/one-inc-guest-payment.guard';
import { FaqPayInFullComponent } from '@loggedin-content/faq/faq-pay-in-full/faq-pay-in-full.component';
import { AcmicGuard } from './_guards/acmic.guard';

const appRoutes: Routes = [
  { path: 'login/callback', component: OktaCallbackComponent },
  { path: 'app-shell', component: AppShellComponent },
  { path: 'pay-bill/:a/:b', component: PayBillComponent },
  { path: 'forgotpassword/:emailPrefill', component: ForgotPasswordComponent },
  { path: 'forgotpassword', component: ForgotPasswordComponent },
  { path: 'profilepassword/:emailPrefill', component: ForgotPasswordComponent },
  { path: 'createpassword', component: CreateNewPasswordComponent },
  { path: 'createnewpassword', component: CreateNewPasswordComponent },
  { path: 'updatepassword', component: CreateNewPasswordComponent },
  { path: 'login', redirectTo: '', pathMatch: 'full' },
  { path: 'loading', component: LoadingComponent },
  { path: 'agent/unsubscribe', component: AgentNotificationComponent },
  { path: 'make-payment', component: MakePaymentComponent },
  { path: 'save-payment', component: RegisterPaymentComponent, canActivate: [AcmicGuard] },
  { path: 'save-payment-widget', component: RegisterPaymentWidgetComponent, canActivate: [AcmicGuard, OneIncGuestPaymentGuard] },
  { path:'make-payment-guest',component:MakePaymentWidgetComponent, canActivate: [OneIncGuestPaymentGuard]},
  {
    path: 'paperless',
    component: BillingStufferComponent,
    children: [
      { path: '', component: PaperlessBillingStuffEnrollFormComponent },
      { 
        path: 'already-enrolled', component: PolicyAlreadyEnrolledComponent 
      },
      {
        path: 'enrollment-request-sent', component: PaperlessEnrollmentRequestComponent
      }
    ]
  },
  { path: 'paperless/does-not-match', component: EnrollDataDoesnotMatchComponent },
  { path: 'paperless/enrollment-success', component: SuccessfullPaperlessEnrollmentComponent },
  {
    path: 'make-payment/:policyid/new-guest-payment',
    runGuardsAndResolvers: 'always',
    component: AchPaymentComponent,
    canActivate: [AchGuestPaymentGuard],
  },
  {
    path: 'make-payment/:policyid/confirm',
    runGuardsAndResolvers: 'always',
    component: AchBillingConfirmComponent,
    canActivate: [AchGuestPaymentGuard],
  },
  {
    path: 'make-payment/:policyid/payment-confirmation',
    component: AchGuestPaymentConfirmComponent,
  },
  { path: 'make-payment-epay', component: AutopayGuestComponent },
  {
    path: 'make-payment/:policyid/payment-error/:errorCode',
    component: MakePaymentErrorComponent,
  },
  {
    path: 'opps',
    component: ErrorComponent,
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      { path: '400', component: Error400Component },
      { path: '401', component: Error401Component },
      { path: '403', component: Error403Component },
      { path: '404', component: Error404Component },
      { path: '408', component: Error408Component },
      { path: '410', component: Error410Component },
      { path: '500', component: Error500Component },
      { path: '502', component: Error502Component },
      { path: '503', component: Error503Component },
      { path: '504', component: Error504Component },
      { path: 'maintence', component: ErrorMaintenceComponent },
      { path: 'link-expire', component: ErrorLinkExpireComponent },
    ],
  },
  { path: 'policy/bop', component: BopComponent },
  {
    path: 'select-account-type',
    component: CreateAccountTypeSelectionComponent,
  },
  {
    path: 'signup',
    component: SignupComponent,
    children: [
      { path: '', component: SignupProcessComponent },
      {
        path: 'create-commercial-account',
        component: CreateCommercialAccountComponent,
      },
      {
        path: 'add-policy',
        component: SignupAddPolicyComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'bop',
        component: SignupBopComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'createpassword',
        component: SignupCreatePasswordComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'createnewpassword',
        component: SignupCreatePasswordComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'edit-policy',
        component: SignupEditPolicyComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'validate-phone',
        component: ValidatePhoneComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'acount-verification',
        component: AccountVerificationComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'phone-otp',
        component: PhoneOtpComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'confirm-email',
        component: ConfirmEmailComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'activate-email',
        component: AccountActivateForLegacyComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'validate-account',
        component: ValidateAccountComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'account-exists',
        component: AccountExistsComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'email-in-use',
        component: SignupEmailInUseComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'not-found',
        component: SignupNotFoundComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'not-found-ca',
        component: NotFoundCommercialComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'x-attempts',
        component: XAttemptsComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'add-policy-error',
        component: PersonalAssistanceComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'policy-belongs-to-another',
        component: SignupPolicyLinkedToAnotherEmailComponent, // canActivate: [SignUpGuard]
      },
      {
        path: 'validate-email',
        component: ValidateEmailScreenComponent, // canActivate: [SignUpGuard]
      },
      {
        path: 'validate-email-ca',
        component: CommercialValidateEmailComponent,
      },
      {
        path: 'validate-account-email-phone',
        component: ValidateAccountEmailPhoneComponent,
        canActivate: [SignUpGuard],
      },
      {
        path: 'expired-link',
        component: LinkExpireComponent,
      },
    ],
  },
  { path: 'testing', component: TestingComponent },
  { path: 'service/message', component: ServiceMessageComponent },
  {
    path: 'verifyaccount',
    component: VerifyAccountComponent, // canActivate: [VerifyUserGuard]
  },
  { path: 'profile/change-email', component: ChangeEmailComponent },
  // when logged in
  {
    path: 'documents/:documentId',
    component: LoadDocumentsComponent,
    canActivate: [AuthGuard],
  },
  { path: 'policy/add', component: DashboardComponent },
  { path: 'offline', component: DashboardComponent },
  {
    path: '',
    component: DashboardMainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: LoggedinContentComponent,
        children: [
          { path: '', redirectTo: 'home', pathMatch: 'full' },
           { path: 'home', component: MyInsuranceHomeComponent },
          {
            path: 'my-insurance',
            component: MyInsuranceComponent,
            children: [
              {
                path: '',
                component: MyInsuranceMainComponent,
                pathMatch: 'full',
              },
              { path: 'link-policy', component: LinkPolicyComponent },
              { path: 'add-policy', component: AddPolicyToAccountComponent },
              {
                path: 'business-policy-not-supported',
                component: BusinesspolicyDetectedComponent,
              },
              { path: 'policy-not-found', component: PolicyNotFoundComponent },
              {
                path: 'account-exists',
                component: PolicyAccountExistsComponent,
              },
              {
                path: 'error-not-found',
                component: InformationNotMatchComponent,
              },
              {
                path: 'no-email-gw',
                component: EmailNotAssociatedWithPolicyComponent,
              },
              {
                path: 'email-not-match',
                component: EmailDoesntMatchTheAccountComponent,
              },
              {
                path: 'edit-policy-details',
                component: EditPolicyDetailsComponent,
              },
              {
                path: 'policy-in-process',
                component: PolicyInProcessComponent,
              },
              {
                path: 'validate-policy-rights',
                component: ValidatePolicyRightsComponent,
              },
              {
                path: 'policy-belongs-to-another',
                component: AddPolicyConflictsComponent,
              },
              { path: 'payment', component: PaymentusCardComponent },
              { path: 'reportClaim', component: PaymentusCardComponent },
              { path: 'payment/wallet', component: PaymentusCardComponent },
              {
                path: ':policyid',
                children: [
                  { path: '', redirectTo: 'details', pathMatch: 'full' },
                  { path: 'details', component: PolicyDetailsComponent },
                  {
                    path: ':index/updatemileage',
                    component: OdometerUpdateComponent,
                  },
                  { path: 'billing', component: BillingDetailsComponent },
                  { path: 'billing-request', component: BillingRequestComponent },
                  { path: 'self-request',
                  children: [
                    { path: 'cancellations', component: CancellationRequestComponent },
                    { path: 'success', component: RequestSuccessComponent },
                  ]},
                  { path: 'billing-discount', component: BillingDiscountComponent },
                  { path: 'refund-request', component: BillingRefundRequestComponent },
                  { path: 'initiate-refund', component: InitiateRefundComponent },
                  { path: 'discount-success', component: BillingDiscountSuccessComponent },
                  { path: 'coverages', component: CoveragesComponent },
                  { path: 'documents', component: DocumentDetailsComponent },
                  {
                    path: 'documents/:documentId',
                    component: LoadDocumentsComponent,
                  },
                  {
                    path: 'change-address/:address-type',
                    component: AddressChangeComponent,
                  },
                  { path: 'other-request', component: OtherRequestComponent },
                  { path: 'other-request-success', component: OtherRequestSuccessComponent },
                ],
              },
            ],
          },
          {
            path: 'profile',
            component: ProfileSettingsComponent,
            children: [
              { path: '', component: ProfileMainComponent },
              { path: 'edit-phone', component: ProfilePhoneComponent },
              { path: 'add-phone', component: ProfilePhoneComponent },
              {
                path: ':policyid/edit-checking-account',
                component: ProfileCheckingAccountComponent,
              },
              {
                path: ':policyid/add-checking-account',
                component: ProfileCheckingAccountComponent,
              },
              {
                path: 'change-address/:address-type',
                component: AddressChangeComponent,
              },
              {
                path: 'enter-password',
                component: ProfileEditPasswordComponent,
              },
              { path: 'verify-password', component: ProfileEditEmailComponent },
              {
                path: 'edit-email',
                component: ProfileEditEmailComponent,
                canActivate: [ChangeProfileSettingsEmailGuard],
              },
              {
                path: 'edit-password',
                component: ProfileEditPasswordComponent,
                canActivate: [ChangeProfileSettingsPasswordGuard],
              },
              {
                path: 'email-confirmation',
                component: ProfileEmailConfirmComponent, // canActivate: [ChangeProfileSettingsEmailGuard]
              },
              {
                path: 'delete-payment-inst-success',
                component: DeletePaymetInstSuccessComponent,
              },
              {
                path: 'delete-payment-inst-error',
                component: DeletePaymetInstErrorComponent,
              },
              {
                path: 'manage-contact-details',
                component: ManageContactComponent,
              },
              {
                path: 'edit-contact',
                component: EditContactComponent,
              },
              {
                path: 'two-factor-authentication',
                component: TwoFactorAuthenticationComponent,
              },
              {
                path: 'edit-two-factor-authentication',
                component: EditTwoFactorAuthenticationComponent,
              },
              {
                path:'wallet-details',
                component:WalletDetailsComponent, canActivate: [OneIncManageWalletGuard]
              }
            ],
          },
          {
            path: 'claims',
            component: ClaimsComponent,
            children: [
              { path: '', component: ClaimsHomeComponent },
              {
                path: ':claimid',
                children: [
                  { path: '', redirectTo: 'details', pathMatch: 'full' },
                  { path: 'details', component: ClaimsDetailComponent },
                  { path: 'documents', component: ClaimDocumentsComponent },
                  {
                    path: 'upload-documents',
                    component: UploadDocumentComponent,
                    canDeactivate: [ExitPageGuard],
                  },
                ],
              },
              {
                path: 'exposures/:id/details',
                component: ExposuresDetailComponent,
              },
            ],
          },
          {
            path: 'billing',
            component: BillingComponent,
            children: [
              { path: '', component: BillingMainComponent },
              { path: 'autopay', component: AutopayComponent },
              {
                path: ':policyid/unenrolled',
                component: AutopayUnenrolledComponent,
              },
              {
                path: ':policyid/payment-info-updated',
                component: PaymentInformationUpdatedComponent,
              },
              {
                path: 'upload-files',
                component: UploadPolicyBillingDocumentComponent,
                // canDeactivate: [ExitPageGuard],
              },
              {
                path: 'paperless',
                component: PaperlessComponent,
                children: [
                  { path: '', component: PaperlessFirstTimeComponent },
                  { path: 'e-bill', component: PaperlessBillComponent },
                  {
                    path: ':policyid/enrollement',
                    component: PaperlessEnrollementComponent,
                  },
                  {
                    path: 'enrollement',
                    component: PaperlessEnrollementComponent,
                  },
                  {
                    path: 'e-pay',
                    children: [
                      { path: '', component: PaperlessPayComponent },
                      {
                        path: ':policyid/enroll',
                        component: PaperlessPayEnrollComponent,
                      },
                      {
                        path: ':policyid/edit-enroll',
                        component: PaperlessPayEnrollComponent,
                      },
                      {
                        path: ':policyid/confirm',
                        component: PaperlessPayConfirmComponent,
                      },
                    ],
                  },
                  { path: 'e-policy', component: PaperlessPolicyComponent },
                ],
              },
              {
                path: ':policyid',
                children: [
                  { path: '', redirectTo: 'new-payment', pathMatch: 'full' },
                  {
                    path: 'new-payment',
                    component: BillingNewpaymentComponent,
                  },
                  {
                    path: 'confirm',
                    component: BillingConfirmComponent,
                    canActivate: [BillinConfirmGuard],
                    runGuardsAndResolvers: 'always',
                  },
                  {
                    path: 'payment-confirmation',
                    component: PaymentConfirmationComponent,
                    canActivate: [BillinConfirmGuard],
                    runGuardsAndResolvers: 'always',
                  },
                  {
                    path: 'payment-error/:errorCode',
                    component: PaymentErrorComponent,
                  }
                ]
              }
            ],
          },
          {
            path: 'billing-new',
            component: BillingContainerComponent,
            children: [
              { path: '', redirectTo: 'billing-landing', pathMatch: 'full' },
              {
                path: 'billing-landing',
                component: BillingPolicySelectorComponent
              },
              {
                path: ':policyid',
                children: [
                  { path: '', redirectTo: 'details', pathMatch: 'full' },
                  { path: 'details', component: BillingNewDetailsComponent },
                  { path: 'make-a-payment', component: BnMakeAPaymentComponent},
                  { path: 'documents', component: BnDocumentsComponent },
                ]
              }
            ]
          },
          {
            path: 'information',
            component: InformationComponent,
            children: [
              { path: '', component: InformationHomeComponent },
              { path: 'products', component: InformationProductsComponent },
              { path: 'about', component: InformationAboutComponent },
              { path: 'discounts', component: InformationDiscountsComponent },
              { path: 'renewal', component: InformationRenewalComponent },
              { path: 'cancel', component: InformationCancelComponent },
              { path: 'legal', component: InformationLegalComponent },
            ],
          },
          {
            path: 'faq',
            component: FaqComponent,
            children: [
              { path: '', component: FaqHomeComponent },
              { path: 'billing', component: FaqBillingComponent },
              { path: 'claims', component: FaqClaimsComponent },
              { path: 'other-questions', component: FaqOtherQuestionsComponent },
              { path: 'policy', component: FaqPolicyComponent },
              { path: 'autopay', component: FaqAutopayComponent },
              { path: 'pay-in-full', component: FaqPayInFullComponent },
            ],
          },
          { path: 'contact', component: ContactComponent },
          { path: 'id-cards', component: IdCardsWrapperComponent },
        ],
      },
    ],
  },
  { path: 'edit-checking-account', redirectTo: '', pathMatch: 'full' },
  { path: 'documents', redirectTo: '', pathMatch: 'full' },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: '/opps/404' }, // otherwise redirect to home
];


// Standalone: export appRoutes for use with RouterModule.forRoot in main.ts
export { appRoutes };
export const routerProviders = appRoutes;

